var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button is-primary is-size-7-mobile",on:{"click":_vm.exportCsv}},[_c('fa-icon',{attrs:{"icon":"file-download"}}),_vm._v(" "),_c('span',{staticClass:"is-hidden-touch"},[_vm._v(" ")]),_vm._v(" "),_c('span',{directives:[{name:"translate",rawName:"v-translate"}],staticClass:"is-hidden-touch"},[_vm._v("Export to CSV")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }